<!-- LEFT: Home button + Search bar -->
<div class="header-left">
  <button class="hdr-home-btn" (click)="navigateDashboard()" title="Dashboard">
    <nb-icon icon="home-outline" pack="eva"></nb-icon>
  </button>

  <div class="hdr-search-wrap">
    <nb-icon icon="search-outline" pack="eva" class="hdr-search-icon"></nb-icon>
    <input
      type="text"
      class="hdr-search-input"
      placeholder="Search analytics, orders, or reports..."
    />
  </div>
</div>

<!-- RIGHT: Org switcher (multi-org) + Org brand -->
<div class="header-right">
  <div class="org-switcher" *ngIf="organizations.length > 1">
    <nb-select
      [selected]="activeOrgId"
      (selectedChange)="onOrgSwitch($event)"
      size="small"
      placeholder="Switch org">
      <nb-option *ngFor="let org of organizations" [value]="org._id">
        {{ org.identifier }}
      </nb-option>
    </nb-select>
  </div>

  <div class="org-brand" *ngIf="organizationName">
    <div class="org-brand-logo-wrap" *ngIf="organizationLogo">
      <img [src]="organizationLogo" class="org-brand-logo" alt="org logo" />
    </div>
    <div class="org-brand-fallback" *ngIf="!organizationLogo">
      {{ organizationName.charAt(0).toUpperCase() }}
    </div>
    <span class="org-brand-name">{{ organizationName }}</span>
  </div>
</div>
